// Valori del contratto GET /moda/articoli; nessuna classificazione degli stati nel client.
const backfillChoices = [
  { value: "DA_AVVIARE", label: "Da avviare" },
  { value: "IN_CORSO", label: "In corso" },
  { value: "DA_RIVEDERE", label: "Da rivedere" },
  { value: "IN_ERRORE", label: "In errore" },
  { value: "COMPLETATI", label: "Completati" },
];
const translationChoices = [
  { value: "DA_TRADURRE", label: "Da tradurre" },
  { value: "PRONTE", label: "Pronte" },
  { value: "NON_ONLINE", label: "Non online" },
  { value: "ONLINE", label: "Online" },
];

export const STATO_ARTICOLI_QUICK_SEARCH_GROUPS = [
  { key: "statoBackfillVigBot", label: "VIG → BOT", choices: backfillChoices },
  { key: "statoBackfillBotVig", label: "BOT → VIG", choices: backfillChoices },
  { key: "statoBackfillRecuperoBot", label: "Recupero BOT", choices: backfillChoices },
  { key: "statoBackfillImmaginiBot", label: "Immagini BOT", choices: [
    { value: "DA_CONTROLLARE", label: "Da controllare" },
    { value: "IN_CORSO", label: "In corso" },
    { value: "NESSUNA_SORGENTE", label: "Nessuna sorgente" },
    { value: "IN_ERRORE", label: "In errore" },
    { value: "RIFIUTATI", label: "Rifiutati" },
    { value: "COMPLETATI", label: "Completati" },
  ] },
  { key: "statoTraduzioniVig", label: "Traduzioni VIG", choices: translationChoices },
  { key: "statoTraduzioniBot", label: "Traduzioni BOT", choices: translationChoices },
];
